import { Button, ButtonGroup } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Certificate from "./pages/Certificate";
import Complete from "./pages/Complete";
import Confirm from "./pages/Confirm";
import Input from "./pages/Input";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Signature from "./pages/Signature";

const App: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <BrowserRouter>
      <div style={{ textAlign: 'right' }}>
        <ButtonGroup variant="text" color="secondary" style={{ marginTop: 20 }}>
          <Button onClick={() => changeLanguage('ja')}>日本語</Button>
          <Button onClick={() => changeLanguage('en')}>English</Button>
          <Button onClick={() => changeLanguage('cn')}>中文 (简体)</Button>
          <Button onClick={() => changeLanguage('tw')}>中文 (繁體)</Button>
          <Button onClick={() => changeLanguage('ko')}>한국어</Button>
        </ButtonGroup>
      </div>
      <Routes>
        <Route path={`/login/:chainUid/:unitUid/:acctNo`} element={<Login />} />
        <Route path={`/login/:chainUid/:unitUid/:acctNo/:password`} element={<Login />} />
        <Route path={`/input`} element={<Input />} />
        <Route path={`/signature`} element={<Signature />} />
        <Route path={`/certificate`} element={<Certificate />} />
        <Route path={`/confirm`} element={<Confirm />} />
        <Route path={`/complete`} element={<Complete />} />
        <Route path={`*`} element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
